
import { Options, Vue } from 'vue-class-component';
import OHou from './components/OHou.vue';

@Options({
  components: {
    OHou,
  },
})
export default class App extends Vue {}
